import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class Reservation extends React.Component {
    // constructor(props) {
    //     super(props);
    //   }
  state = {
    open: false,
    sent: false,
    error: null,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSend = () => {
      const data={
        email: this.state.email,
        debut: this.props.dates.start.format("DD/MM/YYYY"),
        fin: this.props.dates.end.format("DD/MM/YYYY"),
        message: this.state.message
      };
        fetch('https://www.homemalo.com/hmservice/reservation', {
            method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Request error');
          }
        })
        .then(data => this.setState({ data: data, open: false }))
        .catch(error => this.setState({ error: error, open: false }));
  
  };

  handleEmailChange = (e) => {
    this.setState({ email:  e.target.value});
  };

  handleMessageChange = (e) => {
    this.setState({ message:  e.target.value});
  };


  render() {
    return (
      <div>
        <Button variant="contained" color="primary" disabled={this.props.dates==null} onClick={this.handleClickOpen}>Réservation</Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Demande de réservation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Séjour du
                {" "}
                {this.props.dates?this.props.dates.start.format("DD/MM/YYYY"):''}
                {" au "}
                {this.props.dates?this.props.dates.end.format("DD/MM/YYYY"):''}
            </DialogContentText>
            <br/>
            <DialogContentText>
              Merci de renseigner les champs suivants pour la réservation:
            </DialogContentText>
            <br/>
            <TextField
              required
              autoFocus
              margin="dense"
              id="name"
              label="Email"
              type="email"
              fullWidth
              onChange={this.handleEmailChange}
            />
            <TextField
               margin="dense"
              id="messsage"
              label="Message"
              type="text"
              fullWidth
              multiline
              rows={5}
              onChange={this.handleMessageChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Annuler
            </Button>
            <Button onClick={this.handleSend} color="primary">
              Envoyer
            </Button>
          </DialogActions>
        </Dialog>
        <p>{(this.state.sent)?'Demande de réservation envoyée merci':''}</p>
        <p>{(this.state.error)?JSON.stringify(this.state.error):''}</p>
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Reservation.js